module.exports = __webpack_public_path__ + "static/z-8b-ee0ad64be58efedaf226ddc06dbddfc4.jpg";